import type { ReactNode } from 'react';

export const symbol_snowboarding: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M752-60q-8 0-17.5-1T716-64L211-172q-42-9-75.5-36T82-276l-2-8q0-8 6.5-14t14.5-6q6 0 10 3t7 8q17 32 43.5 54t57.5 29l23 5 149-101-33-156q-2-12-.5-27.5T366-515l110-175H358l-58 93q-7 11-18 13.5t-22-3.5q-11-7-14-19t4-23l67-107q4-7 11-10.5t15-3.5h205q23 0 37.5 13t19.5 24l21 48q18 42 54 71.5t82 39.5q12 2 20 12t8 22q0 12-8.5 20.5T762-493q-57-9-104-43t-79-85l-85 136 128 103q5 4 7.5 9t3.5 10l38 249 53 11q7 2 14 2.5t14 .5q24 0 49-10t45-29q1-1 13-5 9 0 15 6.5t6 15.5q0 4-2 8t-5 6q-26 24-58 36t-63 12Zm-144-67-33-215-136-97 18 142q1 8-2.5 15.5T444-269l-120 81 284 61Zm39-647q-30 0-51.5-21.5T574-847q0-30 21.5-51.5T647-920q30 0 51.5 21.5T720-847q0 30-21.5 51.5T647-774Z"
		/>
	</svg>
);
